<template>
  <div class="register-page tw:h-screen tw:flex tw:flex-col tw:bg-white">
    <RegisterHeader />
    <RegisterForm />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted } from "vue";
import RegisterHeader from "vue-app-new/modules/Register/components/RegisterHeader/RegisterHeader.vue";
import RegisterForm from "vue-app-new/modules/Register/features/RegisterForm/RegisterForm.vue";
import { saveUtmToCookies, removeUtmFromCookies } from "vue-app-new/modules/Register/Register.helpers";

const handleBeforeUnload = () => {
  removeUtmFromCookies();
};

onMounted(() => {
  window.addEventListener("beforeunload", handleBeforeUnload);
  saveUtmToCookies();
});

onUnmounted(() => {
  window.removeEventListener("beforeunload", handleBeforeUnload);
});
</script>

<style>
.register-page {
  font-size: 16px;

  @media (min-width: 768px) {
    font-size: 12px;
  }

  @media (min-width: 1536px) {
    font-size: 16px;
  }

  @media (min-width: 1920px) {
    font-size: 17px;

    .EdroneButton {
      height: 100%;
    }
  }

  @media (min-width: 2560px) {
    font-size: 17px;
  }

  @media (min-width: 3840px) {
    font-size: 20px;
  }

  @media (min-width: 5120px) {
    font-size: 24px;
  }
}
</style>
